module.exports = __webpack_public_path__ + "static/lighthouse@fiferries.4d94f4c5.jpg";